<template>
	<Row class="bg-white">
		<Container>
			<article class="post-178 page type-page status-publish entry">
				<header class="entry-header legal-disclosure">
					<h1
						v-if="post && post.title"
						v-html="post && post.title"
						class="entry-title text-[36px] mb-3 text-slate-900"
					></h1>
					<p class="text-[18px] pb-0 text-slate-900 font-normal">
						By {{ post.author.node.name }} from StocksToTrade
					</p>
				</header>

				<div
					class="entry-content legal-disclosure"
					v-html="post.content"
				></div>
			</article>
		</Container>
	</Row>
	<Head>
		<Title>Disclaimer - StocksToTrade</Title>
		<Meta
			name="description"
			content="Last Revised: March 4, 2024 Nothing in this Privacy Statement may be construed to create any obligation for the Company beyond what is required by applicable law. California residents click here to access our California Consumer Protection Act (CCPA) Notice. This Privacy Statement (“Privacy Statement” or “Statement”) describes the practices of StocksToTrade.Com Inc. (“StocksToTrade,” “STT,”…"
		/>
		<Link
			:href="config.current_hostname.slice(0, -1) + '/disclaimer/'"
			rel="canonical"
		/>
		<Meta
			:content="config.current_hostname.slice(0, -1) + '/disclaimer/'"
			property="og:url"
		/>
	</Head>
</template>

<script setup>
const config = useRuntimeConfig().public;
const disclaimerPageDataKey = "disclaimer-page-data";

const { data } = await useAsyncData(disclaimerPageDataKey, async () => {
	try {
		const results = await $fetch(
			`${config.hostname}wp-json/wp/v2/pages?slug=disclaimer&_embed`
		);
		const page = results?.[0];
		if (page) {
			const wpAuthor = page._embedded?.author?.[0];
			return {
				post: {
					title: page.title.rendered,
					content: page.content.rendered,
					author: {
						node: {
							name: wpAuthor?.name ?? "",
							firstName: wpAuthor?.first_name ?? "",
							lastName: wpAuthor?.last_name ?? "",
							description: wpAuthor?.description ?? ""
						}
					}
				},
				metadata: page.yoast_head_json,
				yoast: page.yoast_head
			};
		}
	} catch (error) {
		console.log({ error });
	}
});

const { post } = data.value;
</script>

<style lang="scss">
@use "~/assets/legal-pages" as *;
</style>
